import { useEffect, useState } from 'react'
import { api } from '../../lib/api'
import { SEAL_APPROVERS } from '../../lib/memoTerms'
import { Alert, Loading } from '../../components/ui'
import PdfStamper from './PdfStamper'

/**
 * 合約用印：把公司的合約專用章蓋到對方簽回的 PDF 上。
 *
 * 印章固定用 /seal-a.png，不開放更換——公司章不該由使用者自己上傳，
 * 否則這一頁就變成「任何人都能製作蓋著公司章的文件」。
 * 能開這一頁的只有 SEAL_APPROVERS 名單內的人（與備忘錄列印帶章的判斷同一份名單）。
 */
export default function ContractSeal() {
  const [email, setEmail] = useState<string | null>(null)

  useEffect(() => {
    api.get<{ user: { email: string } }>('/me')
      .then((d) => setEmail(d.user.email))
      .catch(() => setEmail(''))
  }, [])

  if (email === null) return <Loading />

  if (!SEAL_APPROVERS.includes(email)) {
    return (
      <>
        <div className="page-head"><h2>合約用印</h2></div>
        <Alert kind="error">
          合約專用章限授權人員使用，目前登入的帳號（{email || '未知'}）沒有權限。
          如果要蓋自己的印章，請改用「一般用印」。
        </Alert>
      </>
    )
  }

  return (
    <PdfStamper
      title="合約用印"
      hint="公司合約專用章"
      sealSrc="/seal-a.png"
      defaultWidthMm={50}
      rememberKey="winho.seal.pos.contract"
    />
  )
}
